export const VALUE_SEPARATOR = "_"
export const PROGRAM_COURSE_SEPARATOR = " > "
export const PROGRAM_COURSE_SPACE_SEPARATOR = " "
export const STANDARDS_SEPARATOR = "::"
export const IS_GROUP_STANDARD = /^[^:]+::$/ //checks for anything on the right with :: to get the group
export const NO_PROGRAM_VALUE = "No Program"
